import { AvailableTimes } from 'pages/schedules/interface';
import { IBadge, IFrequency, IWaitingMedia } from 'pages/sessions/interface';
import { IHighlightMedia } from 'pages/articles/interface';
import { ISessionMeta } from '../sessions-create/interface';

export interface IModuleSession {
  id: string;
  title: string;
  thumbnailUrl: string;
  sessionType: string;
  audienceType: string;
}

export interface IModuleContent {
  id: string;
  title: string;
  contentUrl: string;
  fileType: string;
  description: string;
}

export interface ISummaryModule {
  name: string;
  session: IModuleSession[];
  form: string[];
  content: IModuleContent[];
  badge: IBadge;
}

export interface ISessionUser {
  id: string,
  avatar: string;
  name: string;
}

export interface ISessionUpdate {
  user: ISessionUser,
  notification: string;
  date: string;
}

export interface ISessionSummary {
  user: ISessionUser | null;
  userSessionId:string;
  bookedAt: string;
  completedAt: string;
  isCompleted: boolean;
  isCancel: boolean;
  meetingId?: string;
  slot?: {
    from: string;
    to: string;
  }
  userType: string;
}

export interface IGroupedSessionSummary {
  meetingId: string;
  sessions: ISessionSummary[];
}

export interface ISessionSummaryItem {
  title: string;
  date: string;
  timestamp: number;
  userSessionId?:string;
  slot: {
    from: string;
    to: string;
  } | undefined;
  isCompleted: boolean;
  isCancel: boolean;
  deleted?: boolean;
  meetingId?: string;
  user?: ISessionUser;
  purchases?: ISessionUpdate[];
}

export interface IStatistic {
  allTimeSessionPurchased: number;
  weeklyTimeSessionPurchased: number;
  userEnrolled: number;
  completed: number;
}

export interface IInvitations {
  _id: string;
  userEmail: string;
  type: string;
  resourceId: string;
  status: string;
}

export interface ISession {
  id: string;
  isActive: boolean;
  sessionType: string;
  audienceType: string;
  invitePeople?: string[];
  invitations?: IInvitations[];
  title: string;
  description: string;
  language: string;
  numberOfSessions: number;
  waitingRoomMedia: IWaitingMedia;
  numberOfParticipants: number;
  isObserverAllowed: boolean;
  numberOfObservers: number;
  forms: string[];
  media: string[];
  availableTimes: AvailableTimes[];
  frequency: IFrequency;
  fee: string;
  discount: string;
  currency: string;
  subscriberFee: string;
  subscriberCurrency: string;
  subscriberDiscount: string;
  observerFee: string;
  observerDiscount: string;
  observerCurrency: string;
  subscribeObserverFee: string;
  subscribeObserverCurrency: string;
  subscribeObserverDiscount: string;
  summary: ISessionSummary[],
  updates: ISessionUpdate[],
  modules: ISummaryModule[];
  statistics: IStatistic,
  badge: IBadge,
  purchaseHistory: ISessionUpdate[],
  bookedSessions: number;
  bookedObservers: number;
  availableSessions: number;
  availableParticipants: number;
  availableObservers: number;
  sessionMeta?: ISessionMeta;
  deleted: boolean;
  deletedAt: string;
  prerequisites?: { id: string; title: string; }[];
  highlightMedia: IHighlightMedia;
}

export interface SessionSummaryState {
  loading: boolean;
  actionLoading: boolean;
  session: ISession;
  sessionUrl: string;
}
export interface ISessionSummaryAction {
  payload: string;
  type:string;
}

export interface IGenerateSession {
  entId: string;
  entUrl: string;
  sessionId: string;
  expertId: string;
  name: string;
  role: string;
  sessionType: string;
  title: string;
  isObserverAllowed: boolean;
  meetingId: string;
  firstName: string;
  lastName: string;
  userId: string;
  profileImgUrl: string;
  email: string;
}
export interface IGenerateSessionStateAction {
  payload: IGenerateSession;
  type: string;
}

export interface ISessionSummeryUpdate {
  id: string;
  audienceType?: string;
  isActive?: boolean;
  invitePeople?: string[];
  resolve?: any;
  reject?: any;
}

export interface ISessionDelete {
  resolve: any;
  reject: any;
  id: string;
  reasonForDeletion: string | null;
  linkedSessionId: string | null | undefined;
}

export interface ISessionInvitationUpdate {
  id: string;
  invitePeople: string[];
}

export interface ISessionSummaryUpdateAction {
  payload: ISessionSummeryUpdate;
  type:string;
}

export interface ISessionDeleteAction {
  payload: ISessionDelete;
  type:string;
}

export interface ISessionInvitationUpdateAction {
  payload: ISessionInvitationUpdate;
  type:string;
}

export interface ISupport {
  feedbackType: string;
  feedback: string;
  reference?: string;
  referenceType?: ReferenceType;
}

export interface ISupportAction {
  payload: ISupport;
  type: string;
}

export enum SupportFeedbackTypes {
  bug = 'Bug',
  compaint = 'Complaint',
  improvement = 'Improvement',
}

export enum ReferenceType {
  GENERAL = 'general',
  SESSION = 'session',
}
